/// <amd-module name="TFS/Token/PatTokenPage/Components/Panels/Panel.ConfirmRevokeOrRegenerate" />
import { PanelOperationType } from 'Actions/PanelActionCreator';
import { Dialog } from "VSSUI/Dialog";
import { IPanelProps } from "VSSUI/Panel"
import { FontWeights, mergeStyleSets } from "OfficeFabric/Styling";
import { memoize } from "VSS/Core/Util/Memoize";
import * as React from 'react';
import * as Resources from "TFS/Token/PatTokenPage/Resources";
import { Token } from 'Models/Token';

export interface IConfirmRevokeOrRegeneratePanelProps extends Pick<IPanelProps, "onDismiss"> {
    operation: PanelOperationType,
    token: Token,
    revokeToken: (authorizationId: string) => Promise<void>,
    addToken: (newToken: Token) => Promise<void>,
}

export class ConfirmRevokeOrRegeneratePanel extends React.Component<IConfirmRevokeOrRegeneratePanelProps, {}> {
    constructor(props: IConfirmRevokeOrRegeneratePanelProps) {
        super(props);
    }

    @memoize
    private static getStyles() {
        return mergeStyleSets({
            contentContainer: {
                display: "flex",
                flexDirection: "column",
            },
            footerContainer: {
                flex: "auto",
                display: "flex",
                alignItems: "center",
                paddingTop: "20px",
                selectors: {
                    " > * + *": {
                        paddingLeft: "4px",
                    },
                },
            },
            footerButtons: {
                marginRight: "16px"
            },
            tokenName: {
                fontWeight: FontWeights.bold
            },
        })
    }

    public render() {
        const { token, operation } = this.props;
        const styles = ConfirmRevokeOrRegeneratePanel.getStyles();
        const descriptionText = operation === PanelOperationType.ConfirmRevoke
            ? Resources.ConfirmRevokeText
            : Resources.ConfirmRegenerate

        return (
            <Dialog
                onDismiss={this.props.onDismiss}
                titleProps={{ text: Resources.Confirmation }}
                footerButtonProps={[
                    {
                        primary: true,
                        className: styles.footerButtons,
                        onClick: operation === PanelOperationType.ConfirmRevoke ? this.revokeToken : this.regenerateToken,
                        text: operation === PanelOperationType.ConfirmRevoke ? Resources.Revoke : Resources.Regenerate
                    },
                    {
                        className: styles.footerButtons,
                        onClick: this.props.onDismiss,
                        text: Resources.Cancel
                    }
                ]}
            >
                <div>
                    <span>{descriptionText + " "}</span>
                    <span className={styles.tokenName}>{token.displayName}</span>
                </div>
            </Dialog>
        )
    }

    private revokeToken = (): void => {
        const { token } = this.props;
        try {
            this.props.revokeToken(token.authorizationId);
            if (this.props.onDismiss) {
                this.props.onDismiss();
            }
        } catch (ex) {
            this.setState({ errorMessage: ex });
        }
    }

    private regenerateToken = async () => {
        const { token } = this.props;
        this.setState({ isMakingApiCall: true });
        try {
            await this.props.revokeToken(token.authorizationId);
            token.authorizationId = "";

            // Take the absolute value just in case of reversed from-to
            const duration = Math.abs(token.validTo.valueOf() - token.validFrom.valueOf());
            token.validTo = new Date(Date.now() + duration);

            this.props.addToken(token);
        } catch (ex) {
            this.setState({ errorMessage: ex, isMakingApiCall: false });
        }
    }
}
